import _createClass from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _possibleConstructorReturn from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _wrapNativeSuper from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/wrapNativeSuper.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * Mint the short-lived orqestrator cookie.
 *
 * The Aira frontend calls orqestrator directly, so it needs a credential
 * orqestrator can verify on its own. The platform issues one in exchange for
 * the session this browser already has.
 *
 * Nothing here handles the token itself: the platform returns it as an
 * httpOnly cookie scoped to .qure.ai, so JS cannot read it, and the browser
 * attaches it to orqestrator calls automatically. All we get back is how long
 * it lasts.
 *
 * Goes through `servicesUtils` like every other call in the app, which is what
 * supplies the base URL (including the on-premise variant), `withCredentials`
 * so the session goes out and the new cookie comes back, the `x-csrftoken`
 * header Django needs on a POST, the timeout and retry, and the shared error
 * reporting. Hand-rolling `fetch` here would quietly opt out of all of it.
 */
import { get } from "lodash";
import servicesUtils from "../../utils/servicesUtils";
export var OrqTokenError = /*#__PURE__*/function (_Error) {
  function OrqTokenError(message, status) {
    var _this;
    _classCallCheck(this, OrqTokenError);
    _this = _callSuper(this, OrqTokenError, [message]);
    _this.name = "OrqTokenError";
    _this.status = status;
    return _this;
  }
  _inherits(OrqTokenError, _Error);
  return _createClass(OrqTokenError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
/** In-flight mint, shared so concurrent callers do not each start one.
 *  Two parallel 401s would otherwise mint twice, and the second response
 *  would overwrite the first cookie mid-flight. */
var inFlight = null;

/**
 * Ask the platform for a fresh orqestrator cookie.
 *
 * Rejects with an `OrqTokenError` carrying the HTTP status, because the two
 * common failures are both expected states rather than bugs: 404 means the
 * feature is off for this deployment, 401 means the session has gone. Callers
 * can tell them apart and stay quiet accordingly.
 */
export function mintOrqToken() {
  if (inFlight) return inFlight;
  inFlight = servicesUtils.postService("/llm_orchestrator/orq-token/", {}).then(function (data) {
    return {
      expiresIn: data.expires_in,
      expiresAt: Date.now() + data.expires_in * 1000
    };
  })["catch"](function (err) {
    throw new OrqTokenError("Could not mint orqestrator token", get(err, ["response", "status"]));
  })["finally"](function () {
    // Cleared once settled, so the next expiry mints again rather than
    // handing back a resolved promise for a cookie that has since died.
    inFlight = null;
  });
  return inFlight;
}